import type { CMYKColor } from "#public"
import type { RGBColor } from "#public"
import type { ColorComponent } from "#public"

/**
 * Converts CMYK color to RGB color
 * Assumes CMYK values are in range 0-1
 */
export const CmykToRgb = ({ alpha, cyan, black, magenta, yellow }: CMYKColor): RGBColor => ({
  alpha,
  blue: ((1 - yellow) * (1 - black)) as ColorComponent,
  green: ((1 - magenta) * (1 - black)) as ColorComponent,
  red: ((1 - cyan) * (1 - black)) as ColorComponent,
})
